// Note: All the files in this directory have been adapted without changes from https://github.com/kodyl/react-document-meta/commit/b35bb4ed6ee38ea18267e5b40e41aa2e8935f15d
// This was done since it is abanondware and needed to be updated to use a newer version of react-side-effect in order to use react 17+
// The longer term goal is to replace the functionality from these components with react-helmet-async
import React from 'react';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';
import ExecutionEnvironment from 'exenv';

import { clone, defaults } from 'components/react-document-meta/utils';
import { insertDocumentMeta } from 'components/react-document-meta/dom';

function reducePropsTostate(propsList) {
  const props = {};
  const dynamicProps = {
    title: undefined,
    description: undefined,
    canonical: undefined
  };

  let extend = true;
  for (let i = propsList.length - 1; extend && i >= 0; i--) {
    extend = propsList[i].hasOwnProperty('extend');

    const _props = propsList[i];
    const _cloned = clone(propsList[i]);
    ['title', 'description', 'canonical'].forEach(key => {
      if (_props.hasOwnProperty(key)) {
        if (typeof _props[key] === 'function') {
          dynamicProps[key] = _props[key](dynamicProps[key]);
        } else if (dynamicProps[key] === undefined) {
          dynamicProps[key] = _props[key];
        }
      }
    });

    defaults(props, _cloned);
  }

  if (typeof dynamicProps.title === 'string') {
    props.title = dynamicProps.title;
  }
  if (typeof dynamicProps.description === 'string') {
    defaults(props, {
      meta: { name: { description: dynamicProps.description } }
    });
  }
  if (typeof dynamicProps.canonical === 'string') {
    defaults(props, { link: { rel: { canonical: dynamicProps.canonical } } });
  }

  if (props.auto && props.auto.ograph) {
    ograph(props);
  }

  if (props.meta && props.meta.charset && !props.meta.charSet) {
    const { charset, ...meta } = props.meta;
    props.meta = {
      charSet: charset,
      ...meta
    };
  }

  return props;
}

function handleStateChangeOnClient(props) {
  if (ExecutionEnvironment.canUseDOM) {
    if (typeof props.title === 'string') {
      document.title = props.title;
    }
    insertDocumentMeta(getTags(props));
  }
}

function ograph(p) {
  if (!p.meta) {
    p.meta = {};
  }
  if (!p.meta.property) {
    p.meta.property = {};
  }

  const group = p.meta.property;
  if (group) {
    if (p.title && !group['og:title']) {
      group['og:title'] = p.title;
    }
    if (p.hasOwnProperty('description') && !group['og:description']) {
      group['og:description'] = p.description;
    }
    if (p.hasOwnProperty('canonical') && !group['og:url']) {
      group['og:url'] = p.canonical;
    }
  }
  return p;
}

function parseTags(tagName, props = {}) {
  const tags = [];
  const contentKey = tagName === 'link' ? 'href' : 'content';
  Object.keys(props).forEach(groupKey => {
    const group = props[groupKey];
    if (typeof group === 'string') {
      tags.push({
        tagName,
        [groupKey]: group
      });
      return;
    }
    Object.keys(group).forEach(key => {
      const values = Array.isArray(group[key]) ? group[key] : [group[key]];
      values.forEach(value => {
        if (value !== null) {
          tags.push({
            tagName,
            [groupKey]: key,
            [contentKey]: value
          });
        }
      });
    });
  });
  return tags;
}

function getTags(_props) {
  return [].concat(_props.base ? [{ tagName: 'base', href: _props.base }] : [], parseTags('meta', _props.meta), parseTags('link', _props.link));
}

export function render(meta = {}) {
  let i = 0;
  const tags = [];

  function renderTag(entry) {
    const { tagName, ...attr } = entry;

    if (tagName === 'meta' || tagName === 'link' || tagName === 'base') {
      return React.createElement(tagName, {
        ...attr,
        'key': i++,
        'data-rdm': true
      });
    }
    return null;
  }

  if (meta.title) {
    tags.push(<title key={i++}>{meta.title}</title>);
  }

  return tags.concat(getTags(meta).map(renderTag));
}

// Note this was rewritten from the source to just be a pure function
const DocumentMeta = ({ children }) => {
  const count = React.Children.count(children);
  return count === 1 ? React.Children.only(children) : count ? <div>{children}</div> : null;
};
DocumentMeta.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  canonical: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  base: PropTypes.string,
  meta: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]))])
  ),
  link: PropTypes.objectOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]))),
  auto: PropTypes.objectOf(PropTypes.bool)
};

const DocumentMetaWithSideEffect = withSideEffect(reducePropsTostate, handleStateChangeOnClient)(DocumentMeta);

DocumentMetaWithSideEffect.renderAsReact = function rewindAsReact() {
  return render(DocumentMetaWithSideEffect.rewind());
};

export default DocumentMetaWithSideEffect;
